import * as M from "@discovery/prelude/lib/data/maybe";
import { pushErrorPageEvent } from "@discovery/common-dplus/lib/adobe";
import { useGlobalState, useHistory } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import * as styles from "./styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { Link, LinkKind } from "../../../components/atoms/link";
import Strings from "../../../utils/hardcoded.json";
import { RestrictedShowErrorPage } from "../../molecules/parental-lock/components/restricted-show-error-page";
import { ErrorPageView } from "./view";
import { Spinner } from "../../../components/atoms/spinner";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
import { useWindowSize } from "../../../utils/hooks";
import { navigateTo } from "../../../utils/common";
export const ErrorPage404 = ({ isUrlRestricted, read }) => {
    return isUrlRestricted && isUrlRestricted > 0 ? (React.createElement(RestrictedShowErrorPage, { read: read })) : (React.createElement(ErrorPageView, null));
};
export const ErrorPageGeneric = () => {
    return (React.createElement("div", { className: styles.errorPage },
        React.createElement(Typography, { classNameM: M.of(styles.errorMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.SOMETHING_WENT_WRONG)),
        React.createElement(Typography, { classNameM: M.of(styles.getBackMsg), variant: HeaderVariants.headingTwo, tag: Tags.h1 },
            React.createElement(React.Fragment, null, Strings.GET_INTOUCH)),
        React.createElement(Link, { href: `mailTo:${"hello@discovery.com"}`, kind: LinkKind.external, openInNewWindow: true },
            React.createElement("div", { className: styles.button }, Strings.EMAIL_SUPPORT))));
};
const ErrorCodePage = ({ error, read }) => {
    const [userM] = useGlobalState(_user);
    const [, history] = useHistory();
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const authRedirectUrl = localStorage.getItem("authRedirectUrl");
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    pushErrorPageEvent("404: Error", isAnonymous, userType, userId);
    const getErrorDetail = M.fromMaybe(error.detail, "");
    const webAuthUrl = read.authService.protocol + "://" + read.authService.domain;
    const myAccount = webAuthUrl + config.authenticationURLs.myAccount;
    const login = webAuthUrl + config.standardPageRouteFragments.login;
    // TODO
    // Since sonic is not sending different error code for restricted
    // shows/videos. Using regex we are matching the reasonCode
    // fix it when sonic sends proper error code
    const matchReasonCode = getErrorDetail.match(/reasonCode=7/g);
    const isUrlRestricted = matchReasonCode && matchReasonCode.length;
    const [width] = useWindowSize();
    if (window.location.pathname === "/my-account") {
        const returnUrl = isAnonymous
            ? `${login}?returnUrl=${myAccount}`
            : myAccount;
        setAuthRedirectUrl("/home");
        window.location.replace(returnUrl);
        return (React.createElement("div", { className: styles.loaderWrapper },
            React.createElement(Spinner, { displayInCenterOfPage: true })));
    }
    else if (authRedirectUrl) {
        setTimeout(() => {
            localStorage.removeItem("authRedirectUrl");
        }, 0);
        width <= 699 ? history.push(authRedirectUrl) : navigateTo(authRedirectUrl);
        return (React.createElement("div", { className: styles.loaderWrapper },
            React.createElement(Spinner, { displayInCenterOfPage: true })));
    }
    else if (window.location.pathname === config.authenticationURLs.authRedirect &&
        authRedirectUrl === null) {
        history.push("/");
        return React.createElement(React.Fragment, null);
    }
    else {
        switch (error.code) {
            case "not.found":
                return React.createElement(ErrorPage404, { isUrlRestricted: isUrlRestricted, read: read });
            default:
                return React.createElement(ErrorPageGeneric, null);
        }
    }
};
export const ErrorPage = ({ errors, read, }) => errors.reduce((_acc, x) => React.createElement(ErrorCodePage, { error: x, read: read }), React.createElement(React.Fragment, null));

